import React from 'react';
import DocumentTitle from 'react-document-title';

import Link from 'ui/Link';

import 'css/ui/screens/ProjectsScreen.css';



class ProjectsScreen extends React.Component {

	render() {
		return (
			<div className="projects-screen">
				<DocumentTitle title="Projects - Caleb Miller" />
				<h2 className="fade-slide-up">Project gallery coming soon!</h2>
				<p className="fade-slide-up anim-delay-1">
					You can still check me out on{' '}
					<Link to="https://codepen.io/MillerTime/" external light>
						CodePen
					</Link>
				</p>
			</div>
		);
	}
}

export default ProjectsScreen;



// WEBPACK FOOTER //
// ./src/ui/screens/ProjectsScreen.jsx